import { FollowTargetTypeEnum } from '../../enums';

export interface CardFollowInterface {
  targetType: FollowTargetTypeEnum;
  targetId: string;
}
